module.exports = __webpack_public_path__ + "img/iso.d7d4352d.png";